// @docs https://[domain]/api/v1/docs
export default {
  List: "/orgcharts",
  CreateDept: "/orgcharts/dept",
  UpdateDept: "/orgcharts/dept",
  DeleteDept: "/orgcharts/dept",
};
